import { RealizationResultItem } from "types/realization";
import {FaPlay, FaTrophy} from 'react-icons/fa';
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale/pt-BR";
import { GrDownload } from "react-icons/gr";

interface Options{
    data:RealizationResultItem,
    position:number;
}

const CardResult = ({data, position}: Options) =>{
    return (
      <article className={`flex flex-col card winner-card`}>
        <div className={`flex justify-between items-start`}>
          <div className="flex items-center gap-1 uppercase flag">
            <FaTrophy color={"#F6F630"} width={24} />
            <span className={`text-sm font-bold font-bb text-yellow-bb-1`}>
              {" "}
              {position}º Lugar 
            </span>
          </div>
          <div className="justify-start tag md:justify-end">
            {data.categoria && <span>{String(data.categoria)}</span>}
          </div>
        </div>
        <h2 className="mt-3 mb-2 text-lg font-medium font-bb text-black-bb">
          <strong>Realização: </strong>
          {data.title}
        </h2>

        <div className="flex-1 p-4 detail bg-gray-bb-3">
          <p className="text-sm font-bold text-black-bb">
            <strong>Cadastrado por</strong>
          </p>
          <p>
            {data.owner_name} ({data.owner}), em{" "}
            {data.dt_aceite
              ? format(
                  typeof data.dt_aceite === "string"
                    ? parseISO(data.dt_aceite)
                    : new Date(data.dt_aceite),
                  "dd 'de' MMMM 'de' yyyy",
                  {
                    locale: ptBR,
                  }
                )
              : "Data inválida"}
          </p>
          <p className="mt-4 text-sm font-bold text-black-bb">
            <strong>Detalhes da realização</strong>
          </p>
          <p dangerouslySetInnerHTML={{ __html: data.description }} />

          <p className="mt-4 text-sm font-bold text-black-bb">
            <strong>Participantes da realização mais votados</strong>
          </p>
          {data.indicados && [...data.indicados]
            .sort((a, b) => a.nome.localeCompare(b.nome))
            .map((item) => (
              <p className="text-base text-gray-bb-2 font-bb" key={item.matricula}>
                <strong>
                  {item.nome}({item.matricula})
                </strong>
              </p>
            ))}
          <div className=""></div>

          {!!data.documento && data.documento.length > 0 ? (
            <>
              <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
                <strong>Documentação complementar da realização</strong>
              </p>
              {data.documento.map((item) => (
                <>
                  {!!item && item !== null && (
                    <>
                      {item.type === "video" ? (
                        <div className="relative mt-6">
                          <div>
                            <button>
                              <a
                                href={item.file}
                                className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                                target="_blank"
                                rel="noreferrer"
                              >
                                <FaPlay />
                                Ver vídeo
                              </a>
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="mt-6">
                          <button
                            className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                            onClick={() => {
                              window.open(item.file, "_blank");
                            }}
                          >
                            <GrDownload size={22} />
                            Download
                          </button>
                        </div>
                      )}
                    </>
                  )}
                </>
              ))}
            </>
          ) : (
            <></>
          )}
        </div>
      </article>
    );
}

export default CardResult;